import { css } from '@emotion/react'
import { useNavigate } from 'react-router'

import authService from '~/@common/services/auth.service'
import modalService from '~/@common/services/modal.service'
import Button from '~/@common/ui/(Button)/Button/Button'
import Modal from '~/@common/ui/modal/Modal'
import { getEntrancePage } from '~/@common/utils/getEntrancePage'

const StudentWorksheetNotFoundModal = () => {
  const navigate = useNavigate()

  const handleClickHome = () => {
    navigate(getEntrancePage(authService.userType))
    modalService.closeModal()
  }
  return (
    <Modal.Confirm.Default>
      <div css={_css}>
        <div>
          삭제된 학습지이므로 이동할 수 없습니다.
          <br />
          아래 &apos;홈으로 가기&apos; 버튼을 눌러
          <br />
          메인 화면으로 이동해주세요.
        </div>
        <div>
          <Button onClick={handleClickHome} theme="primary" size="small">
            홈으로 가기
          </Button>
        </div>
      </div>
    </Modal.Confirm.Default>
  )
}

export default StudentWorksheetNotFoundModal

const _css = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 24px;
  color: var(--color-gray-800);
`
